var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 29.5,
    height: 29.5,
    rx: 4.75,
    stroke: "#F1CC08",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5393 22.9997C15.3584 22.9997 14.1997 22.9997 13.0272 22.9997C13.0272 19.2259 13.0272 15.4583 13.0272 11.6723C14.1377 11.6723 15.252 11.6723 16.3952 11.6723C16.3952 12.1764 16.3952 12.6755 16.3952 13.1801C16.6385 12.8968 16.844 12.6106 17.0962 12.3727C17.7162 11.7871 18.4743 11.4826 19.316 11.4056C20.0441 11.3385 20.7672 11.3917 21.4699 11.6113C22.6402 11.9773 23.3301 12.8003 23.6742 13.9493C23.9025 14.7118 23.9839 15.4965 23.9895 16.2851C24.0044 18.4784 23.9983 20.6722 24.0006 22.8655C24.0006 22.8927 23.9956 22.9193 23.9917 22.9642C22.8258 22.9642 21.6627 22.9642 20.4747 22.9642C20.4747 22.8827 20.4747 22.8023 20.4747 22.7213C20.4736 20.8464 20.4785 18.9708 20.4669 17.0959C20.4647 16.7038 20.4287 16.3067 20.3583 15.9208C20.145 14.7556 19.3886 14.3514 18.2947 14.4861C17.3123 14.607 16.7748 15.186 16.6252 16.2541C16.5709 16.6428 16.5454 17.0393 16.5437 17.4319C16.5354 19.2032 16.5398 20.9745 16.5398 22.7463C16.5393 22.8272 16.5393 22.9082 16.5393 22.9997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.793 22.9997C9.62435 22.9997 8.46622 22.9997 7.29425 22.9997C7.29425 19.2204 7.29425 15.4483 7.29425 11.6646C8.46179 11.6646 9.61991 11.6646 10.793 11.6646C10.793 15.4405 10.793 19.2077 10.793 22.9997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0778 8.03482C11.0839 9.16224 10.1701 10.0967 9.05525 10.1033C7.93425 10.11 7.00055 9.17389 7 8.04259C6.99945 6.93014 7.91264 6.00957 9.02699 5.99959C10.1508 5.98961 11.0717 6.90352 11.0778 8.03482Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(7 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin_icon.1e0fca475aa8a2ea5efc4c0cde304cce.svg";
export { ForwardRef as ReactComponent };